var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  "+_vm._s(_vm.humanDay)+", "+_vm._s(_vm.humanTime)+" Uhr\n")])}
var staticRenderFns = []

export { render, staticRenderFns }